module.exports = __webpack_public_path__ + "img/shoot_00002.3bbbfcdd.png";